<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title">
			<!-- <span @click="go" style="margin-left: 20px;">返回</span> -->
			<!-- <el-divider direction="vertical"></el-divider> -->

		</div>
		<div style="display: flex;align-items: center;justify-content: center;height: 10px;">
			{{title}}
		</div>
		<div style="padding: 50px;">
			<el-form v-model="storelinks">
				<div style="display: flex;">
					<el-form-item label-width="100px" label="客户:">
						<el-select filterable v-model="storelinks.customerId" class="big" placeholder="请选择" clear>
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单号:" label-width="85px">
						<el-input type="text" style="width: 220px; " placeholder="请输入订单号"  v-model="orderInfo.orderCode"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label-width="90px" label="订单类型:">
						<el-select filterable v-model="storelinks.type"  placeholder="请选择" clear>
							<el-option v-for="it in typeList" :key="it.id" :value="it.id"
								:label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="承运日期:" label-width="100px" >
						<el-date-picker value-format="yyyy-MM-dd" v-model="storelinks.sendDate" placeholder="选择承运日期:">
						</el-date-picker>
					</el-form-item>
				</div>


				<div style="display: flex;">
					<el-form-item label-width="100px" label="线路选择:" >
						<el-select filterable v-model="storelinks.routeId" style="width: 220px;" class="big" placeholder="请选择" clear>
							<el-option v-for="it in routeList" :key="it.id" :value="it.id"
							
								:label="it.routeName"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label-width="85px" label="计费方式:">
						<el-select filterable v-model="storelinks.billingType"  placeholder="请选择" clear>
							<el-option :value="1" label="按趟次单价">按趟次单价</el-option>
							<el-option :value="2" label="按方数单价">按方数单价</el-option>
							<el-option :value="3" label="按吨数单价">按吨数单价</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="运输数量(吨/方):" label-width="120px" v-if="storelinks.billingType==2||storelinks.billingType==3">
						<el-input type="text" style="width: 150px; " v-model="storelinks.number"
							auto-complete="off" placeholder="请输入运输数量" />
					</el-form-item>
					<el-form-item style="margin-left: 10px;" label="" label-width="120px" v-if="storelinks.billingType==2||storelinks.billingType==3">
						{{storelinks.billingType==2?'方':storelinks.billingType==3?'吨':''}}
					</el-form-item>
					<el-form-item label="运费:" label-width="90px">
						<el-input type="text" style="width: 100px; " v-model="storelinks.freightPrice"
							auto-complete="off" placeholder="请输入运费" />
					</el-form-item>
					<el-form-item label="" label-width="80px" style="margin-left: 20px;">
						<span v-if="storelinks.status==0" style="color: red;">制单中</span>
						<span v-if="storelinks.status==1" style="color: orange;">在途</span>
						<span v-if="storelinks.status==5" style="color: green;">完成</span>
					</el-form-item>
				</div>

				<div style="display: flex;">	
					<el-form-item label="司机:" label-width="100px"  class='tiny' >
						<el-select filterable v-model="storelinks.driverId" class="big" placeholder="请选择" clear>
							<el-option v-for="it in driverList" :key="it.id" :value="it.id"
							@click.native="changesj(it)"
								:label="it.driverName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="车辆:" label-width="85px">
						<el-select style="width: 220px; " filterable v-model="carNumberplate"
						class="big" placeholder="请选择" clear>
							<el-option v-for="it in arsList" 
							:key="it.id" 
							@click.native="carchange(it)"
							:value="it.carNumberplate"
							:label="it.carNumberplate"
							
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="isJoinCar==1" l label-width="100px" style="color: green;display: flex;align-items: center;">
						<span style="width: 50px;">挂靠</span>
					</el-form-item>
					<el-form-item v-if="isJoinCar==0"  label-width="100px" style="color: green;display: flex;align-items: center;">
						<span style="width: 50px;">自有</span>
					</el-form-item>
					<el-form-item label="司机提成:" label-width="90px">
						<el-input type="text"  v-model="storelinks.driveSendReward"
							auto-complete="off" placeholder="请输入司机提成" />
					</el-form-item>
					
				<el-form-item label-width="100px" label="订单状态:">
					<el-select style="width: 200px;" filterable v-model="storelinks.status" disabled class="big" placeholder="请选择" clear>
						<el-option :value="0" label="制单中">制单中</el-option>
						<el-option :value="1" label="在途">在途</el-option>
						<el-option :value="5" label="完成">完成</el-option>
					</el-select>
				</el-form-item>
					
				</div>
				
				<div style="display: flex;">
					
					<el-form-item label="木板带板数量:" label-width="100px" >
						<el-input v-model="storelinks.floorslabNum" placeholder="请输入木板带板数量">
						</el-input>
					</el-form-item>
					
					<el-form-item label="数量:" label-width="100px" >
						<el-input v-model="storelinks.totalNum" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入数量"  style="width: 220px; ">
							 <template slot="append">台</template>
						</el-input>
					</el-form-item>
					<el-form-item label="体积:" label-width="90px" >
						<el-input v-model="storelinks.volume" type="number" placeholder="请输入体积"  style="width: 220px; ">
							<template slot="append">方</template>
						</el-input>
					</el-form-item>
					<el-form-item label="重量:" label-width="90px" >
						<el-input v-model="storelinks.weight" type="number" placeholder="请输入重量"  style="width: 220px; ">
							<template slot="append">吨</template>
						</el-input>
					</el-form-item>
					
				</div>
				<div style="display: flex;">
					<el-form-item label="木板返回数量:" label-width="100px" >
						<el-input v-model="storelinks.floorslabRebackNum" placeholder="请输入木板返回数量">
						</el-input>
					</el-form-item>
					
					<el-form-item label="备注:" label-width="100px" >
						<el-input v-model="storelinks.remark" placeholder="请输入备注" style="width: 450px;">
						</el-input>
					</el-form-item>
				</div>
				
				<div style="width: 1300px;position: relative;margin-left: 30px;">
					
					<el-form-item label="运输商品" prop="remark">
						
					
						<!-- 添加按钮 -->
						<el-table :data="dataList" size="mini" style="width: 100%;"
						@row-click="handleRowClick"
						current-row-key="index"
						>
						 
							<el-table-column type="index" label="序号" width="50"></el-table-column>
							
							<el-table-column prop="customerOrderCode" label="客户单号" :show-overflow-tooltip="true" min-width="100">
								<template slot-scope="scope">
									<el-input  :id="'sel'+scope.$index"  @blur="aa(scope.$index,scope.row,'customerOrderCode')" v-model.trim="scope.row.customerOrderCode" placeholder="请输入客户单号" clearable>
									</el-input>
								</template>
							</el-table-column>
							<el-table-column prop="pdtCode" label="商品编号" min-width="120">
								<template slot-scope="scope">
									
									  <el-select  :remote-method="input"  
									  filterable  v-model="scope.row.pdtCode" 
									  remote
									 
											@keyup.enter.native="asd(scope.$index,$event)"
											@change="change"
										allow-create
										clearable
									  placeholder="请选择" style="width:200px;">
										  <div style="display: flex;justify-content: space-between;padding: 0 20px;font-size: 14px;">
											<span>  商品名称</span>
											  商品编号
										  </div>
									    <el-option
										
											@click.native="select(scope.$index,item,index)" 
									
									      v-for="(item,index) in dataList1"
									      :key="item.id"
									      :label="item.pdtCode"
									      :value="index">
									      <span style="float: left">{{ item.goodsName }}</span>
									      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span>
									    </el-option>
										</el-select>
								</template>
							</el-table-column>
							
							<el-table-column prop="goodsName" width="200" label="商品名称" align="center"
								class-name="small-padding ">
							</el-table-column>
							<el-table-column prop="num" label="数量" :show-overflow-tooltip="true" min-width="80">
								<template slot-scope="scope">
									<el-input @keyup.enter.native="keydown(scope.$index,scope.row)" 
									 @blur="aa(scope.$index,scope.row,'num')"
									 v-model.trim="scope.row.num" placeholder="请输入数量" clearable>
									</el-input>
								</template>
							</el-table-column>
						
							<el-table-column prop="unitName" label="单位" :show-overflow-tooltip="true" min-width="80">
								<template slot-scope="scope">
									<el-form-item label="单位" class='tiny'>
										<el-select clearable filterable v-model="scope.row.unitName"
											placeholder="请选择单位">
											<el-option v-for="item in unitList" :key="item.id" :label="item.name"
												:value="item.name">
											</el-option>
										</el-select>
									</el-form-item>
								</template>
							</el-table-column>
							
							<el-table-column prop="remark" width="200" label="备注"  align="center"
								>
								<template slot-scope="scope">
									<el-input  @blur="aa(scope.$index,scope.row,'remark')" @keyup.enter.native="keydown(scope.$index,scope.row)" v-model.trim="scope.row.remark" placeholder="请输入备注" clearable>
									</el-input>
								</template>
							
							</el-table-column>
							<el-table-column v-if="storelinks.status!=5" width="80" label="操作" fixed="right" align="center"
								class-name="small-padding fixed-width">
								<template slot-scope="scope">
									<el-button type="text" icon="el-icon-delete"
										@click="handleDelete(scope.$index, scope.row)"></el-button>
										<el-button v-if="aid==scope.row.id"  type="text" 
											@click="cr(scope.$index, scope.row)">保存</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
					

				</div>
				
				<el-button type="primary" v-if="storelinks.status==1" style="float: left;margin-left: 100px;" @click="wanc">完成订单</el-button>
				<el-button type="primary"  v-if="storelinks.status!=5" style="float: right;margin-right: 80px;" @click="submitClick">提交</el-button>
			</el-form>
		</div>
	</div>
</template>

<script>
	import goodsMagnifierZoom from '../../components/goods-zoom.vue';
	  import _ from 'lodash';

	export default {
		props:['order'],
		name: "GoodsZoom",
		components: {
			goodsMagnifierZoom: goodsMagnifierZoom,
		},
		data() {
			return {
				isReturn:true,
				detaillist: {},
				title:'',
				unitList: [],
				arsList:[],
				queryParam: '',
				isJoinCar:3,
				driverList:[],
				num: 1,
				typeList: [],
				flag:false,
				userList: [],
				storelinks: {
					status:0,
					number:0,
					billingType:1,
					type:1,
					sendDate:this.Date()
				},
				orderInfo: {},
				goodsList: [],
				form: {},
				dataList: [
					{
						pdtName: '',
						remark: '',
						
						unitName: '',
					}
				],
				formData: {},
				
				dataList1: [],
				contractList: [],
				typeList: [],
				ids:'',
				aid:0,
				carNumberplate:'',
				routeList: [],
				isDataChangeCount:0
			}
		},
		watch: {
			carNumberplate(newValue, oldValue) {
			
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
			
			
			storelinks:{
				handler(a,b){
				
					if(this.$route.query.id){
						this.isDataChangeCount++
					
					}else{
						this.isDataChangeCount++
						
						
					}
					
				},
				deep:true
			},
			'storelinks.routeId'(a,b){
			
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
					
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
					
					}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
					
					}
					this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
				}else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
						
						}else if(this.storelinks.billingType==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
						
						}
						this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
					}
				}
			
					
				
			},
			
			'storelinks.billingType'(a,b){
				if(!this.$route.query.id){
					if(a==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						
					}else if(a==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
					}else if(a==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
					
					}
				}else{
					if(this.isDataChangeCount>1){
						if(a==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
				
						}else if(a==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
						}else if(a==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
						
						}
					}
				}
				
				
			},
			'storelinks.number'(a,b){
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
					}else if(this.storelinks.billingType==2){
					this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
					
					}
				}
				else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
						
						}
					}
				}
			},
			
		},
		
		methods: {
			
			carchange(it){
				
			},
			Date(){
				 const now = new Date();
					const year = now.getFullYear(); // 获取当前年份
					const month = now.getMonth() + 1; // 月份从 0 开始，所以要加1
					const day = now.getDate(); // 获取当前日期
				return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
			},
			wanc(){
				
				this.$api.completeByID(this.orderInfo.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.init();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			changesj(e){
				
				this.carNumberplate=e.carNumberplate
			},
			   handleRowClick(row, event, column) {
			      // row 对象即为点击的行数据
			
					this.$nextTick(()=>{
						    this.aid=row.id
					})
			    },
			change(e){
			
				this.ids=e
			},
			asd(a,e){
				
				// this.$set(this.dataList,a,{
				// 	goodsName: this.dataList1[this.ids].goodsName,
				// 	id:this.dataList[a].id,
				// 	goodsId:this.dataList1[this.ids].goodsId,
				// 	customerOrderCode:this.dataList1[this.ids].customerOrderCode,
				// 	pdtCode: this.dataList1[this.ids].pdtCode,
				// 	unitName: this.dataList1[this.ids].unitName,
				// })
				this.$set(this.dataList[a],'goodsName',this.dataList1[this.ids].goodsName)
				this.$set(this.dataList[a],'goodsId',this.dataList1[this.ids].goodsId)
				// this.$set(this.dataList[a],'customerOrderCode',this.dataList1[this.ids].customerOrderCode)
				this.$set(this.dataList[a],'pdtCode',this.dataList1[this.ids].pdtCode)
				this.$set(this.dataList[a],'unitName',this.dataList1[this.ids].unitName)
				this.$set(this.dataList[a],'id',this.dataList[a].id)
			},
			keydown(index,b){
					let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					goodsName:b.goodsName,
					goodsId:b.goodsId,
					customerOrderCode:b.customerOrderCode,
					unitName:b.unitName,
					remark:b.remark,
					num:b.num,
				}
				if(b.id){
					this.$api.uporderList(this.$encrypt({...data,id:b.id})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
					
						if(res.state=='success'){
							this.dataList=res.data
							this.handleAdd()
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
						}else{
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addorderL(this.$encrypt(data)).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.handleAdd()
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
						}else{
							// console.log('0000000000');
							this.$message.error(res.message)
						}
					})
				}			
				
			
			
				
			},
			submitClick(){
				
				 if (this.$vnode && this.$vnode.data.keepAlive){
				              if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache){
				                  if (this.$vnode.componentOptions){
				                      var key = this.$vnode.key == null? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag
				                      ? `::${this.$vnode.componentOptions.tag}` : ''): this.$vnode.key;
				                      var cache = this.$vnode.parent.componentInstance.cache;
				                      var keys  = this.$vnode.parent.componentInstance.keys;
				                      if (cache[key]){
				                          if (keys.length) {
				                              var index = keys.indexOf(key);
				                              if (index > -1) {
				                                  keys.splice(index, 1);
				                              }
				                          }
				                          delete cache[key];
				                      }
				                  }
				              }
				          }
				
				this.$api.fupdateorder(this.$encrypt({...this.storelinks,id:this.orderInfo.id,carNumberplate:this.carNumberplate,orderCode:this.orderInfo.orderCode})).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						// this.$store.commit('setactiveindex','/orderManagement/addorder')
						setTimeout(()=>{
							this.title='编辑订单'
							this.$router.push({
								path: '/orderManagement/addorder'
							})
							this.$store.commit('setactiveindex', '/orderManagement/addorder')
							// this.$router.go(-1)
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			cr(index,b){
				let a='sel'+(index+1)
				
				let data={
					orderId:this.orderInfo.id,
					goodsName:b.goodsName,
					customerOrderCode:b.customerOrderCode,
					goodsId:b.goodsId,
					unitName:b.unitName,
					remark:b.remark,
					num:b.num,
				}
			
				if(b.id){
					this.$api.uporderList(this.$encrypt({...data,id:b.id})).then(res=>{
					
						res=JSON.parse(this.$decrypt(res.data))
								
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addorderL(this.$encrypt(data)).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			
			},
			
			
			select(a,item,index) {
				// console.log(this.dataList);
			   // this.dataList[a]=item
				this.$set(this.dataList[a],'goodsName',item.goodsName)
				this.$set(this.dataList[a],'goodsId',item.goodsId)
				this.$set(this.dataList[a],'index',index)
				this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				this.$set(this.dataList[a],'unitName',item.unitName)
		
			},
			// 添加行
			handleAdd() {
				var _this = this

				let list = {
					pdtName: '',
					remark: '',
					
					unitName: '',
				}

				_this.dataList.push(list)
			},
			// 删除行
			handleDelete(index, row) {
				var _this = this
			
				
				this.$api.deldateorder(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
							_this.dataList.splice(index, 1)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			input(e) {
				this.dataList1=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
							this.dataList1.push({
								goodsName: item.pdtName,
								goodsId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
							})
						})
						this.flag=true
					} else {
						this.dataList1 = []
					}


				})
			},
			goscroll(e) {
			
			},
			goBack() {
				topTarget.scrollIntoView();
			},
			aa(index,b,c){
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					goodsName:b.goodsName,
					customerOrderCode:b.customerOrderCode,
					goodsId:b.goodsId,
					unitName:b.unitName,
					remark:b.remark,
					num:b.num,
				}
							
				if(b.id){
					this.$api.uporderList(this.$encrypt({...data,id:b.id})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦事件返回数据--',res.data);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							// console.log(res);
							this.$message.error(res.message)
						}
					})
				}else{
					// console.log(data);
					this.$api.addorderL(this.$encrypt(data)).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦事件返回数据--',res.data);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
						// console.log(1111111111);
							this.$message.error(res.message)
						}
					})
				}
				
			},
			go() {  
				// console.log(this.$route);
				if(this.storelinks.status==5){
					this.$store.commit('setactiveindex','/orderManagement/addorder')
					this.$router.go(-1)
				}else{
					if(this.$route.query.id){
						if(this.isDataChangeCount>1){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$store.commit('setactiveindex','/orderManagement/addorder')
							this.$router.go(-1)
						}
					}else{
						if(this.isDataChangeCount>0){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$store.commit('setactiveindex','/orderManagement/addorder')
							this.$router.go(-1)
						}
					}
				}
				
				
				
			},
			init(){
				
				this.$api.fidupdateorder(this.$route.query.id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('查询---', res.data)
					this.storelinks=res.data
					this.formData = JSON.parse(JSON.stringify(res.data))
				
					this.carNumberplate=res.data.carNumberplate
					this.orderInfo=res.data
					this.dataList=res.data.orderLists
					if(this.storelinks.status==5){
					
					}else{
					
						this.dataList.push({
							pdtName: '',
							remark: '',
							
							unitName: '',
						})
					
					
					}
					
				})
			},
			save(type) {
			    //   console.log(`调用保存按钮方法--${type}`);
			    },
			 saveContent(e) {
			   var key = window.event.keyCode ? window.event.keyCode : window.event.which;
			   if (key === 83 && e.ctrlKey) {
			     this.save("hot key");
			     e.preventDefault(); //阻止浏览器默认事件
			   }
			   }
		},
	
		 beforeDestroy() {
		    //销毁时移除监听
		    document.removeEventListener("keydown", this.saveContent);
		  },
		mounted() {
			  document.addEventListener("focus", this.saveContent);
		
			
				
		},
		created() {
			if(this.$route.query.id){
				this.title='编辑订单'
				this.init()
			}else{
				this.title='新增订单'
				this.$api.addneworder().then(res => {
				
					this.orderInfo = res.data
				})
			}
			this.$api.fdriverList(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.driverList = res.data
			})
			this.$api.fcarsList(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.arsList = res.data
			})
			
			this.$api.findPmsUnit({}).then(res => {
				
				this.unitList = res.data.list
			})
			this.$api.orderlist({
				position: '运输单'
			}).then(res => {
			
				this.typeList = res.data
			})
			this.$api.findcusomer(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.userList = res.data
			})
			
			this.$api.findrouteList({}).then(res => {
			
				this.routeList = res.data
			})

		}
	}
</script>

<style>
	/* 新建的项目  去一下默认样式 */
	body,
	html {
		padding: 0;
		margin: 0;
	}
</style>
<style leng="less" scoped>
	.container {
		position: relative;
	}

	.detail {
		background: rgb(244, 249, 254);
		width: 880px;
		height: 60px;
		border-radius: 5px;
		padding: 10px;
		line-height: 30px;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}

	.detaildt {
		/* width: 1380px; */
		width: 93%;
		margin: 50px;
		overflow: hidden;
		background: white;
		height: auto;
		border-radius: 10px;
	}
	/deep/.el-select-dropdown,.el-popper{
		width: 500px;
		padding: 0 20px;
	}
</style>